import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import Marquee from "@/sections/Marquee";
import Problem from "@/sections/Problem";
import Solution from "@/sections/Solution";
import HowItWorks from "@/sections/HowItWorks";
import DemoSection from "@/sections/DemoSection";
import Services from "@/sections/Services";
import WhyMatters from "@/sections/WhyMatters";
import CaseStudies from "@/sections/CaseStudies";
import WhoFor from "@/sections/WhoFor";
import Pricing from "@/sections/Pricing";
import Faq from "@/sections/Faq";
import FinalCta from "@/sections/FinalCta";
import About from "@/sections/About";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";
import PrivacyPage from "@/sections/PrivacyPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const HomePage = () => (
  <div className="min-h-screen bg-paper font-sans text-ink">
    <Nav />
    <main>
      <Hero />
      <Marquee />
      <Problem />
      <Solution />
      <HowItWorks />
      <DemoSection />
      <Services />
      <WhyMatters />
      <CaseStudies />
      <WhoFor />
      <Pricing />
      <Faq />
      <FinalCta />
      <About />
      <Contact />
    </main>
    <Footer />
  </div>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </BrowserRouter>
  );
}
